var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewfeedbackFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1409 2.56907L11.7578 4.186C12.1223 4.55039 12.327 5.04461 12.327 5.55994V15.057C12.327 16.1301 11.4571 17 10.384 17H2.94301C1.86991 17 1 16.1301 1 15.057V3.94301C1 2.86991 1.86992 2 2.94301 2H8.76696C9.28227 2 9.77647 2.2047 10.1409 2.56907Z",
    fill: "#EE7233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3257 5.30827H10.6073C9.64085 5.30827 8.85742 4.52484 8.85742 3.55843V2",
    stroke: "white",
    strokeWidth: 0.755614
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 5.30859H6.78887",
    stroke: "white",
    strokeWidth: 0.755614,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 13.4297H6.78887",
    stroke: "white",
    strokeWidth: 0.755614,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 7.71094H9.27017",
    stroke: "white",
    strokeWidth: 0.755614,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 10.5664H9.27017",
    stroke: "white",
    strokeWidth: 0.755614,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7058 13.9662L10.109 12.891C10.1897 12.6757 10.3223 12.4836 10.495 12.3317L14.9802 8.3848C15.4015 8.01406 16.0446 8.05932 16.4098 8.48541C16.7734 8.90953 16.7222 9.54853 16.2957 9.90936L11.6525 13.8381C11.4452 14.0135 11.1913 14.1249 10.9219 14.1585L9.9532 14.2796C9.77912 14.3014 9.6442 14.1304 9.7058 13.9662Z",
    fill: "#EE7233",
    stroke: "white",
    strokeWidth: 0.755614,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfeedbackFilled);
export default __webpack_public_path__ + "static/media/new feedback_filled.661ab9a447f3605b602ad3a4fc4334c7.svg";
export { ForwardRef as ReactComponent };